// Angular
import { Injectable } from '@angular/core';
// RxJS
import { map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// Services
import { ActivityService, UserService } from '../_services';
// State
import { AppState } from '../../reducers';
import {
  ActivityActionToggleLoading,
  ActivityActionTypes,
  ActivityPageLoaded,
  ActivityPageRequested,
  ActivityPageToggleLoading,
} from '../_actions/activity.actions';

@Injectable()
export class ActivityEffects {
  showPageLoadingDistpatcher = new ActivityPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new ActivityPageToggleLoading({ isLoading: false });

  showActionLoadingDistpatcher = new ActivityActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new ActivityActionToggleLoading({ isLoading: false });

  // done
  @Effect()
  loadActivitysPage$ = this.actions$.pipe(
    ofType<ActivityPageRequested>(ActivityActionTypes.ActivityPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.activity.getAllActivity(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin(requestToServer, lastQuery);
    }),
    map((response) => {
      const result: QueryResultsModel = response[0];
      const lastQuery: QueryParamsModel = response[1];
      return new ActivityPageLoaded({
        activities: result.pageOfItems,
        totalCount: result.pager.totalCount,
        page: lastQuery,
      });
    }),
  );

  constructor(
    private actions$: Actions,
    private activity: ActivityService,
    private user: UserService,
    private store: Store<AppState>,
  ) {}
}
